module.exports = __webpack_public_path__ + "media/images/bg_book_mv_pc-47e03ea780f77e984cc04436cfbef598.jpg";